import React from "react"
import Layout from "src/components/Layout"
import ContactCard from "src/components/cards/ContactCard"

export default function About() {
  return (
    <Layout>
      <div className="container">
        <h1 className="heading">About Us</h1>
        <p>
          We are a growing community of dedicated members, including but not
          limited to IT and related industry professionals, teachers, academics
          and undergraduates. We have members from every background, gender and
          religion coming from different parts of Sri Lanka who are scattered
          throughout the world.
        </p>

        <h1 className="heading">Contact Us</h1>
        <p>
          If you need more information or having any issues please let us know
        </p>
        <div className="card_grid">
          <ContactCard
            title="Sanjaya"
            phone="+94768924898"
            email="sanjayaweerakoon1991@gmail.com"
          />
          <ContactCard
            title="Athmajan"
            phone="+94777331084"
            email="athmajan92@gmail.com"
          />
          <ContactCard
            title="Manoj"
            phone="+94777338929"
            email="mnjsamarakoon@gmail.com"
          />
        </div>
        <p className="padding-2">
          Or reach out to via our official email:{" "}
          <strong>nenathambara@gmail.com</strong>
        </p>
      </div>
    </Layout>
  )
}
